// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";
import * as CatalogProduct from "./CatalogProduct.res.js";

function encoder(param) {
  return CatalogProduct.Kind.toString(param.productKind);
}

function decoder(value) {
  let productKind = CatalogProduct.Kind.fromString(value);
  if (productKind.TAG === "Ok") {
    return {
      TAG: "Ok",
      _0: {
        productKind: productKind._0
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "SyntaxError",
        VAL: productKind._0
      }
    };
  }
}

let value = JsonCodec.object1(encoder, decoder, JsonCodec.field("productKind", JsonCodec.string));

let Codecs = {
  encoder: encoder,
  decoder: decoder,
  value: value
};

function encode(state) {
  return QueryString.stringify(JsonCodec.encodeWith(state, value));
}

function decode(query) {
  return JsonCodec.decodeWith(QueryString.parse(query), value);
}

let CreateProduct = {
  Codecs: Codecs,
  encode: encode,
  decode: decode
};

export {
  CreateProduct,
}
/* value Not a pure module */
